// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JoHeader } from './jo-header';
import { ReturnRequestDetail } from './return-request-detail';
import { ReturnRequestStatus } from './return-request-status';
import { ReturnRequestStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReturnRequest extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK joHeader */
  joHeaderId!: number;
  /** String */
  manualCloseExplanation?: string;
  /** Guid */
  proximityReturnRequestId?: string;
  /** DateTimeOffset */
  receivedTs!: Date;
  /** String(50) */
  returnAddress1!: string;
  /** String(50) */
  returnAddress2?: string;
  /** String(50) */
  returnCity!: string;
  /** String(50) */
  returnContact?: string;
  /** String(254) */
  returnEmail?: string;
  /** String(4) */
  returnExt?: string;
  /** String(25) */
  returnFax?: string;
  /** Enum FK returnRequestStatus */
  returnRequestStatusId!: ReturnRequestStatusEnum;
  /** String(10) */
  returnState?: string;
  /** String(25) */
  returnTelephone?: string;
  /** String(10) */
  returnZipCode!: string;
  /** FK joHeaderId */
  joHeader!: JoHeader;
  /** Inv FK returnRequestId */
  returnRequestDetails!: ReturnRequestDetail[];
  /** FK returnRequestStatusId */
  returnRequestStatus!: ReturnRequestStatus;
}

